import { render, staticRenderFns } from "./TaskSeries.vue?vue&type=template&id=7e489eee&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TaskSeries.vue?vue&type=script&lang=js"
export * from "./TaskSeries.vue?vue&type=script&lang=js"
import style0 from "./TaskSeries.vue?vue&type=style&index=0&id=7e489eee&prod&lang=css"
import style1 from "./TaskSeries.vue?vue&type=style&index=1&id=7e489eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e489eee",
  null
  
)

export default component.exports